import React, {useEffect} from "react";
import {useFormikContext} from "formik";
import ErrorMessage from "./ErrorMessage";
import {Form} from "react-bootstrap";

/**
 * Renders a form field with validation and error handling.
 *
 * @param {Object} props - The properties for the form field.
 * @param {string} props.name - The name of the form field.
 * @param {string} props.display - The name of the display field.
 * @param {string} props.width - The width of the form field.
 * @param {string} props.label - The label for the form field.
 * @param {string} props.defaultValue - The default value for the form field.
 * @param {function} props.feedback - The feedback function for the form field.
 * @param {any} props.otherProps - Additional properties for the form field.
 *
 * @return {JSX.Element} - The rendered form field component.
 */
function AppFormField({name, display, width, label, defaultValue, feedback, ...otherProps}) {
    const {setFieldTouched, setFieldValue, errors, touched, values} = useFormikContext();

    useEffect(() => {
        if (values[name] !== "Project") {
            feedback()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values])

    useEffect(() => {
        if (defaultValue) setFieldValue(name, defaultValue)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (display) {
        if (values[display.name] !== display.value) return <></>
    }

    return (
        <>
            {label && <Form.Label>{label}</Form.Label>}
            <Form.Control
                onBlur={() => setFieldTouched(name)}
                onChange={text => setFieldValue(name, text.target.value)}
                value={values[name]}
                width={width}
                {...otherProps}
            />
            <ErrorMessage error={errors[name]} visible={touched[name]}/>
        </>
    );
}

export default AppFormField;
